import { Currency, CurrencyAmount, Percent, Token } from '@kodiak-finance/sdk-core'
import { KX_ROUTER_ADDRESSES, SWAP_ROUTER02_ADDRESSES } from 'constants/addresses'
import { useConnection } from 'hooks/useConnection'
import { useMemo } from 'react'
import { KodiakTrade, Trade } from 'state/routing/trades'

import { useApproval } from '../useApproval'

export { ApprovalState } from '../useApproval'

export function useSwapRouterAddress(activeTrade?: Trade) {
  const { chainId } = useConnection()

  return useMemo(() => {
    if (!chainId) return undefined

    if (activeTrade?.methodParameters?.to) {
      return activeTrade.methodParameters.to
    }

    if (activeTrade instanceof KodiakTrade || activeTrade?.provider === 'Kodiak') {
      return SWAP_ROUTER02_ADDRESSES[chainId]
    }

    if (activeTrade?.isExternal) {
      return KX_ROUTER_ADDRESSES[chainId]
    }

    return KX_ROUTER_ADDRESSES[chainId]
  }, [chainId, activeTrade])
}

// wraps useApproveCallback in the context of a swap
export default function useSwapApproval(
  activeTrade: Trade | undefined,
  allowedSlippage: Percent,
  useIsPendingApproval: (token?: Token, spender?: string) => boolean,
  amount?: CurrencyAmount<Currency> // defaults to trade.maximumAmountIn(allowedSlippage)
) {
  const amountToApprove = useMemo(
    () =>
      amount ||
      (activeTrade && activeTrade.inputAmount.currency.isToken
        ? activeTrade.maximumAmountIn(allowedSlippage)
        : undefined),
    [amount, activeTrade, allowedSlippage]
  )
  const spender = useSwapRouterAddress(activeTrade)

  return useApproval(amountToApprove, spender, useIsPendingApproval)
}
